<template>
    <b-overlay :show="showoverlay" rounded="sm">
    <div>
        
        <div class="row no-margin">
            <div class="col-md-4">
                <h4 class="atlhr-dashboard-title mt-10">Employee Management<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Employee Management</span></h4>
            </div>
            <div class="col-md-8 pr-0">
                <div v-if="employee_id > 0">
                    <employee-previous-next :pageurl="this.$api_url"></employee-previous-next>
                </div>
            </div> 
        </div>
        
        
        <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>
        <b-alert show dismissible fade v-if='warningmsg' variant='warning'>{{warningmsg}}</b-alert>
        <b-alert show dismissible fade v-if='dangermsg' variant='danger'>{{dangermsg}}</b-alert>
        <div  class="clearfix row no-gutters employee-profile" v-if="employee_id > 0">            
            <employee-public-info :pageurl="this.$api_url" :key="c_flg"></employee-public-info>
        </div>
        <div class="employee-tab" :class="{'new-employee-container' : employee_id == 0}">
            <b-tabs v-model="ewtabIndex" pills content-class="" nav-class="pr-2 m-2" nav-wrapper-class="col-md-9 card no-shadow custom-margin custom-tab-nav ml-auto pl-0">
                                
                <template v-if="ce">
                    <b-tab >
                        <template active v-slot:title>Profile</template>                
                        <div class="clearfix">
                            <div class="">
                                <account-employees :pageurl="this.$api_url" :flg="1" v-on:childToParent="getAccountEmployees"></account-employees>
                            </div>
                        </div>
                    </b-tab>
                    
                    <b-tab lazy v-if="employee_id > 0">
                        <template active v-slot:title>Contracts</template>                
                        <div class="clearfix">
                            <div class="">
                                <contract-form :pageurl="this.$api_url" @event="contractChanged"></contract-form>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        <template  v-slot:title>Contracts</template>                
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab>
                    <!-- <b-tab lazy v-if="employee_id > 0"> -->
                    <b-tab lazy v-if="employee_id > 0 && is_enrollment_date"> <!-- Rejwan: 29-01-2025 -->
                        <template active v-slot:title>Provident Fund Summery</template>                
                        <div class="clearfix">
                            <div class="">                            
                                <employee-pf-summery :pageurl="this.$api_url"></employee-pf-summery>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        <template  v-slot:title>Provident Fund Summery</template>                
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab> 
                    <!-- <b-tab lazy v-if="employee_id > 0"> -->
                    <b-tab lazy v-if="employee_id > 0 && is_enrollment_date"> <!-- Rejwan: 29-01-2025 -->
                        <template active v-slot:title>Provident Fund Statement</template>                
                        <div class="clearfix">
                            <div class="">                            
                                <employee-pf-statement :pageurl="this.$api_url"></employee-pf-statement>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        <template  v-slot:title>Provident Fund Statement</template>                
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab> 
                    <!-- <b-tab lazy v-if="employee_id > 0"> -->
                    <b-tab lazy v-if="employee_id > 0 && is_enrollment_date"> <!-- Rejwan: 29-01-2025 -->
                        <template active v-slot:title>Provident Fund Schedule</template> 
                                       
                        <div class="clearfix">
                            <div class="">                            
                                <pf-contributions :pageurl="this.$api_url"></pf-contributions>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        <template  v-slot:title>Provident Fund Schedule</template>                
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab>
                    <!-- <b-tab lazy v-if="employee_id > 0"> -->
                     <b-tab lazy v-if="employee_id > 0 && is_enrollment_date"> <!-- Rejwan: 29-01-2025 -->
                        <template active v-slot:title>Provident Fund Loan</template>                
                        <div class="clearfix">
                            <div class="">                            
                                <pf-employee-loan-list :pageurl="this.$api_url" :employee_id="employee_id" :flg="1"></pf-employee-loan-list>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        <template  v-slot:title>Provident Fund Loan</template>                
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab>

                    <!-- <b-tab lazy v-if="employee_id > 0"> -->
                    <b-tab lazy v-if="employee_id > 0 && is_enrollment_date"> <!-- Rejwan: 29-01-2025 -->
                        <template active v-slot:title>Migrated PF History</template>                
                        <div class="clearfix">
                            <div class="">                            
                                <employee-mpf-info :pageurl="this.$api_url" :flg="1"></employee-mpf-info>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        <template  v-slot:title>Migrated PF History</template>                
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab>


                    

                    <!-- <b-tab lazy v-if="employee_id > 0">
                        
                        <template active v-if="$atl_company_package_title != 'Provident Fund Only'"  v-slot:title>  Rent Free Accommodation</template>   
                        
                        <template v-else active v-slot:title> <b-icon icon="lock-fill" aria-hidden="true" class='lock-icon-trz-tab'></b-icon> Rent Free Accommodation</template>   
                                   
                        <div class="clearfix">
                            <div class="">       
                                <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                    <employee-rfc-info :pageurl="this.$api_url" :flg="1"></employee-rfc-info>
                                </template>
                                <template v-else>
                                    <lock-template :pageurl="pageurl"></lock-template>
                                </template>                      
                                
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        
                        <template active v-if="$atl_company_package_title != 'Provident Fund Only'"  v-slot:title>  Rent Free Accommodation</template>   
                        
                        <template v-else active v-slot:title> <b-icon icon="lock-fill" aria-hidden="true" class='lock-icon-trz-tab'></b-icon> Rent Free Accommodation</template>                 
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab>

                    <b-tab lazy v-if="employee_id > 0">
                        
                        <template active v-if="$atl_company_package_title != 'Provident Fund Only'"  v-slot:title>Migrated Payroll History</template>   
                        
                        <template v-else active v-slot:title> <b-icon icon="lock-fill" aria-hidden="true" class='lock-icon-trz-tab'></b-icon>Migrated Payroll History</template>               
                        <div class="clearfix">
                            <div class="">                            
                                
                                <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                    <employee-mph-info :pageurl="this.$api_url" :flg="1"></employee-mph-info>
                                </template>
                                <template v-else>
                                    <lock-template :pageurl="pageurl"></lock-template>
                                </template>    
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        
                        <template active v-if="$atl_company_package_title != 'Provident Fund Only'"  v-slot:title>Migrated Payroll History</template>   
                        
                        <template v-else active v-slot:title> <b-icon icon="lock-fill" aria-hidden="true" class='lock-icon-trz-tab'></b-icon>Migrated Payroll History</template>              
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab> -->

                    
                    
                    <!-- <b-tab lazy v-if="employee_id > 0">
                         
                        <template active v-if="$atl_company_package_title != 'Provident Fund Only'"  v-slot:title>Loan / Advance</template>   
                        
                        <template v-else active v-slot:title> <b-icon icon="lock-fill" aria-hidden="true" class='lock-icon-trz-tab'></b-icon>Loan / Advance</template>                 
                        <div class="clearfix">
                            <div class="">                            
                                <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                    <employee-loan-list :pageurl="this.$api_url" :flg="1"  :employee_id="employee_id" :bn="this.public_info.name" ></employee-loan-list>
                                </template>
                                <template v-else>
                                    <lock-template :pageurl="pageurl"></lock-template>
                                </template>   
                                
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        
                        <template active v-if="$atl_company_package_title != 'Provident Fund Only'"  v-slot:title>Loan / Advance</template>   
                        
                        <template v-else active v-slot:title> <b-icon icon="lock-fill" aria-hidden="true" class='lock-icon-trz-tab'></b-icon>Loan / Advance</template>             
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab>



                    <b-tab lazy v-if="employee_id > 0">
                        
                        <template active v-if="$atl_company_package_title != 'Provident Fund Only'"  v-slot:title>Documents</template>   
                        
                        <template v-else active v-slot:title> <b-icon icon="lock-fill" aria-hidden="true" class='lock-icon-trz-tab'></b-icon>Documents</template>               
                        <div class="clearfix">
                            <div class="">                            
                                <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                    <employee-documents :pageurl="this.$api_url" :flg="this.permission"></employee-documents>
                                </template>
                                <template v-else>
                                    <lock-template :pageurl="pageurl"></lock-template>
                                </template>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                         
                        <template active v-if="$atl_company_package_title != 'Provident Fund Only'"  v-slot:title>Document</template>   
                        
                        <template v-else active v-slot:title> <b-icon icon="lock-fill" aria-hidden="true" class='lock-icon-trz-tab'></b-icon>Document</template>          
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab> -->



                    

                </template>
                
            </b-tabs>
        </div>
        <b-modal id="bv-modal-employeesearch" size="lg" hide-footer title="Search Employees">
            <keep-alive>
                <search-employees></search-employees>
            </keep-alive>
        </b-modal>
    </div>
    </b-overlay>
</template>
<script>
    
    


    
    export default{
        mounted() {
            this.setTabIndex();
            //this.showoverlay = false;  
            setTimeout(this.showContent , 3000);   
        },
        props: ['pageurl' , 'readonly'],
      
        data(){            
            
            return {
                showoverlay : true,
                cu:window.location.href,
                ce : false,
                pageUrl : this.$api_url,
                pgeUrl : this.$api_url,
                avatarsrc : null,
                employee_id : 0,
                company_id : 0,
                ewtabIndex : 0,
                employee_exists : 'employee-exists',
                public_info : [{name:'', email:'', jobposition:'', department:'', company:'', join_date:'', contract_expire:''}],
                
                isHovered: false,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,

                c_flg: 0, // This variable is for reloading public info
                is_enrollment_date: false, // Rejwan: 29-01-2025
            }
        },
        methods:{
            
            showContent: function()
            {
                this.showoverlay = false;
            },
            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;   
                    if(this.ce == false) this.ewtabIndex = 0;

                }.bind(this));
            }, 
            showSerch: function(){
                this.$bvModal.show('bv-modal-employeesearch');
            },
            
            getEmployeeData: function(){
                if(!this.checkNet()) return false;
                
                this.c_flg += 1;
                //alert('hi');
                /*axios.get(this.$api_url+'/employee/publicinfo')
                    .then(function (response) {
                        
                        this.public_info = response.data;
                        this.company_id = this.public_info.company_id;
                        this.employee_id = this.public_info.employee_id;
                        
                        this.avatarsrc = this.$api_url+'/images/employee/'+ this.company_id + '/' + this.public_info.pic;

                    }.bind(this));*/
            },                        
            handleHover(hovered) {
                
                this.isHovered = hovered
            },
            getAccountEmployees (value) 
            {
                this.employee_id = value.employee_id;
                if(this.employee_id > 0)
                {
                    this.getEmployeeData();
                }                   

            },
            getContractForm (value) 
            {
                this.public_info.contract_expire = value.contract_expire;
            },
            contractChanged(value){
               if(value=='removed' || value=='added'){
                  this.c_flg += 1;
               }
            },
            setTabIndex:function(event)
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/employee/getid')
                    .then(function (response) {
                        if(this.ce == false)
                        {
                            this.ewtabIndex = 0;
                            return;
                        }
                        
                        this.employee_id = response.data;
                        
                        let uri = window.location.href.split('?');
                        if (uri.length == 2)
                        {
                            let vars = uri[1].split('&');
                            let getVars = {};
                            let tmp = '';
                            vars.forEach(function(v){
                                tmp = v.split('=');
                                if(tmp.length == 2)
                                    getVars[tmp[0]] = tmp[1];
                            });
                            //console.log(getVars['#']);
                            if(getVars['#'])
                                this.ewtabIndex = parseInt(getVars['#']);
                            
                        }
                                             
                                            

                    }.bind(this));                
            },
            // Start: Rejwan: 29-01-2025
            getEmployeePFEnrollmentDate() {
                axios.get(this.$api_url+'/pf/employee/pf-enrollment-date', {
                }).then(function (response) {
                    if(response.data.success == true) {
                        this.is_enrollment_date = true;
                    }
                }.bind(this)).catch(function (error){alert(error)});
               
            }
            // End: Rejwan: 29-01-2025
        },
        created: function(){
            //
            this.getAcl();
            this.getEmployeePFEnrollmentDate(); // Rejwan: 29-01-2025  
            //this.getEmployeeData(); 
            //this.setTabIndex();
        }

    }

</script>